/**
 * Subject Localization Utility
 * Maps database subject names to i18n translation keys
 */

// TFunction type from react-i18next
type TFunction = (key: string, options?: any) => string;

/**
 * Subject mapping - handles both Vietnamese and English subject names from database
 */
const SUBJECT_MAP: Record<string, string> = {
  // Vietnamese names (from database)
  Toán: 'mathematics',
  'Vật lí': 'physics',
  'Hóa học': 'chemistry',
  'Sinh học': 'biology',
  'Lịch sử': 'history',
  'Địa lý': 'geography',
  'Tiếng Anh': 'english',
  'Ngữ văn': 'literature',
  Văn: 'literature',

  // English names (from database)
  MATHEMATICS: 'mathematics',
  PHYSICS: 'physics',
  CHEMISTRY: 'chemistry',
  BIOLOGY: 'biology',
  HISTORY: 'history',
  GEOGRAPHY: 'geography',
  ENGLISH: 'english',
  LITERATURE: 'literature',

  // Lowercase English
  mathematics: 'mathematics',
  physics: 'physics',
  chemistry: 'chemistry',
  biology: 'biology',
  history: 'history',
  geography: 'geography',
  english: 'english',
  literature: 'literature',

  // Short names
  math: 'mathematics',
  bio: 'biology',
  chem: 'chemistry',
  geo: 'geography',

  // General subject
  'Tổng hợp': 'general',
  General: 'general',
  GENERAL: 'general',
};

/**
 * Get localized subject name
 * @param subject - Subject name from database
 * @param t - Translation function from useTranslation
 * @returns Localized subject name
 */
export function getLocalizedSubject(subject: string, t: TFunction): string {
  const subjectKey = SUBJECT_MAP[subject] || SUBJECT_MAP[subject.toLowerCase()];

  if (subjectKey) {
    return t(`subjects.${subjectKey}`);
  }

  // Fallback to original subject name if no mapping found
  return subject;
}
